let user = JSON.parse(localStorage.getItem("user"));
const initialState = user ? {loggedIn: true, user} : {}
const LoginReducer = (state = initialState, action) => {
    console.log(action.type,"loooooad");
    switch(action.type){
        case "LOGIN_REQUEST":
            return { loggingIn: true, user: action.payload };
        case "LOGIN_SUCCESS":
            return { loggedIn: true, user: action.payload };
        case "LOGIN_FAIL":
            return { loggedIn: false, error: action.payload };
        case "LOGOUT":
            return { loggedIn: false };
        default:
            return state;
    }
}

export default LoginReducer;